import { createInstance } from '@/helpers/api/base'
import { useCombinedLogsTableStateStore } from '@/modules/CombinedLogs/store'
import { useAuthStore } from '@/store/auth-store'
import { FilterType } from '@/types/logs'
import { IUserShift } from '@/types/user'

export const useInitMileageClerkSession = () => {
    const { setXUserShiftId } = useAuthStore()
    const { setFilter } = useCombinedLogsTableStateStore()

    return async () => {
        const userShiftData = await createInstance<IUserShift>({
            url: '/user-shifts',
            method: 'POST',
            data: {},
        })

        setXUserShiftId(userShiftData.id)
        setFilter(FilterType.MileageLoss)
    }
}
